// ============================================================
// ADVANCE DAILY OCCURRENCE
// ============================================================

export function advanceDaily({

    template,

    currentDate

}) {

    const nextDate = new Date(currentDate)

    const interval = Number(template.interval_value) || 1

    nextDate.setDate(
        nextDate.getDate() + interval
    )

    return nextDate

}